import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

function SvgComponent(props: SvgProps) {
    return (
        <Svg
            width={12}
            height={9}
            viewBox="0 0 12 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <Path
                d="M4.295 9a.88.88 0 01-.636-.276L.26 5.17a.979.979 0 010-1.33.878.878 0 011.273 0l2.761 2.887L10.466.273a.878.878 0 011.273 0 .979.979 0 010 1.331L4.93 8.724A.88.88 0 014.295 9z"
                fill="#fff"
            />
        </Svg>
    );
}

export default SvgComponent;
